// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 266 ? "32ea55aa" : chunkId) + "." + {"67":"aef306e8be6e79fc","83":"540f6172ac8f356c","183":"80c52a7df9df160e","266":"aef5be7fc1d6f591","397":"843bbc6778358ef8","464":"5c23e8fd9e7b2df2","757":"c77b29feb30e8d83"}[chunkId] + ".js";
};